import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

// Column
import { InquiryColumns } from '../../appconfig/DatatableSetting';

// Data table
import { Skeletonitems, SkeletonbodyTemplate, defaultRowOptions, defaultPageRowOptions, paginatorLinks, showingEntries } from '../../appconfig/Settings';

//Services
import { getAllDetails } from '../../service/ProductService';

// Api
import { GET_INQUIRY } from '../../config/ApiConstant';
import { FrontWebsiteTabs } from './FrontWebsiteTab';
import { combinedFullNameTemplate, commonNameTemplate } from '../../appconfig/DatatableTemplateSetting';

export const Inquiry = () => {
    document.title = 'Inquiry List | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(false);
    const [inquiryList, setInquiryList] = useState<any>([]);

    // use effect method
    useEffect(() => {
        getInquiryData();

        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    // Get college list api call
    const getInquiryData = async () => {
        try {
            setPageLoad(false);
            const response = await getAllDetails(GET_INQUIRY);
            if (response) {
                const DataList: any = response;

                if (DataList.length === 0) {
                    setInquiryList([]);
                } else {
                    setInquiryList(DataList);
                }
                setPageLoad(true);
            } else {
                setPageLoad(false);
                setInquiryList([]);
            }
        } catch (error: any) {
            setPageLoad(false);
            setInquiryList([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    //fullnameTemplate
    const fullnameTemplate = (rowData: any) => {
        return <>{rowData?.first_name + ' ' + rowData.last_name}</>;
    };

    return (
        <>
            <FrontWebsiteTabs mainTabLabel="Inquiry" />

            <Toast ref={toast} />

            <div className="grid crud-demo mt-3">
                <div className="col-12">
                    <div className="card">
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={inquiryList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    className="datatable-responsive "
                                    emptyMessage="No Banner Found"
                                    removableSort
                                    rows={defaultRowOptions}
                                    paginator={inquiryList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    paginatorTemplate={paginatorLinks}
                                    currentPageReportTemplate={showingEntries}
                                >
                                    {InquiryColumns.map((col, i) => {
                                        if (col.field === 'name') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={fullnameTemplate} />;
                                        } else if (col.field === 'message') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={commonNameTemplate} />;
                                        } else if (col.field === 'sr_no') {
                                            return <Column key={col.field} header={col.header} body={(_, { rowIndex }) => rowIndex + 1} style={{ minWidth: '5rem' }} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {InquiryColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};
